import { Columns } from '@shared/interfaces/table/column-config';
import { meterFrameStatusPartial } from '@shared/partials/meterframe-status.partial';
import { meterFrameTypePartial } from '@shared/partials/meterframe-type.partial';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { networkPlacementPartial } from '@shared/partials/network-placement.partial';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { MeterFrameDetailsDto } from './meterframe-details.masterdata';

export const meterframeStationMasterdata: Columns<MeterFrameDetailsDto>[] = [
  meterFrameStatusPartial,
  meterFrameTypePartial,
  {
    title: 'meterFrame.identification',
    key: 'identification'
  },
  {
    title: 'meterFrame.transformer',
    key: 'transformer'
  },
  {
    title: 'connectionRight.owner',
    key: 'connectionPointOwnsConnectionRights',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      true: 'connectionRight.ownerConnectionPoint',
      false: 'connectionRight.ownerMeterFrame',
    },
  },
  networkPlacementPartial,
  {
    title: 'meterFrame.Date',
    key: 'connectionDate',
    cellRenderer: DateCellComponent,
  },
  {
    title: 'meterFrame.description',
    key: 'description'
  }
];
